module.exports = __webpack_public_path__ + "static/media/no-data-image.c920e4be.svg";